import React from 'react';
import { CREATE_MAILBOX_MUTATION } from '../../../api/mutations';
import { ICreateMailboxData } from '../forms/CreateMailboxForm';
import { useMutation } from '@apollo/client';
import { MAILBOXES } from '@/api/queries';

const useCreateMailbox = () => {
    const [ createMailbox ] = useMutation(CREATE_MAILBOX_MUTATION, {
        refetchQueries: [MAILBOXES]
    })


    const handleCreateMailbox = async (values: ICreateMailboxData, setError: (error: string) => void) => {

        const req = await createMailbox({ variables: values });

        if (req.data?.createMailbox?.message) {
            if (req.data.createMailbox.__typename == "ErrorType") return setError(req.data?.createMailbox?.message);
            return req.data?.createMailbox?.message
        }

        req.errors && setError(req.errors.toString())
    }

    return {
        createMailbox: handleCreateMailbox
    }
}

export default useCreateMailbox;